'use client';

import { freddyTheme, Link, Popover } from '@coolblue-development/freddy';
import readExplanationInOverlayTrigger from '@coolblue-development/ga4-events/triggers/ProductTradeInOverlay/readExplanationInOverlayTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { ProductTradeInContext } from '@features/product/components/ProductTradeIn/Context';
import { Actions, ExplanationInfo } from '@features/product/components/ProductTradeIn/types';
import { useBreakpoints } from '@hooks/useBreakpoints';
import { useTranslation } from '@i18n/useTranslation';
import { useContext, useState } from 'react';

export const ExplanationLink = ({ explanation, title }: ExplanationInfo) => {
  const { t } = useTranslation('webshop.productTradeIn');
  const [referenceElement, setReferenceElement] = useState<HTMLButtonElement | null>(null);
  const { dispatch } = useContext(ProductTradeInContext);
  const { isMobile } = useBreakpoints();
  const popoverTranslations = useFreddyTranslations('popover');
  const [isOpen, setIsOpen] = useState(false);

  const { trackEvent } = useAnalytics();

  function handleExplanationButtonClick() {
    trackEvent(readExplanationInOverlayTrigger());
    dispatch?.({ type: Actions.SET_EXPLANATION_INFO, payload: { explanation, title } });
    dispatch?.({ type: Actions.SET_EXPLANATION_MODAL, payload: true });
    setIsOpen(true);
  }

  return (
    <>
      <Link
        component='button'
        sx={{ fontSize: freddyTheme.typography.fontSize.md }}
        ref={setReferenceElement}
        onClick={handleExplanationButtonClick}
        onMouseEnter={!isMobile ? handleExplanationButtonClick : undefined}
        onMouseLeave={!isMobile ? () => setIsOpen(false) : undefined}
        type='button'
      >
        {t('questionExplainerButtonLabel')}
      </Link>
      {!isMobile && (
        <Popover
          translations={popoverTranslations}
          referenceElement={referenceElement}
          open={isOpen}
          onClose={() => setIsOpen(false)}
          withCloseButton={false}
          placement='bottom'
          sx={{
            fontSize: freddyTheme.typography.fontSize.md,
            fontWeight: 'normal',
            boxShadow: freddyTheme.shadow.stronger
          }}
        >
          {explanation}
        </Popover>
      )}
    </>
  );
};
